export default {
    url: '/finished',
    template: '<feedback-finished/>'
};



// WEBPACK FOOTER //
// ./src/app/states/feedback/finished/index.js